import { lazy } from 'react';
import { authRoles } from 'auth/authRoles';
import Loadable from 'ui-component/Loadable';

const List = Loadable(lazy(() => import('./List')));
const Create = Loadable(lazy(() => import('./Create')));
const Update = Loadable(lazy(() => import('./Update')));
const View = Loadable(lazy(() => import('./View')));

const castingRoutes = [
    {
        path: '/casting/create',
        element: <Create />,
        auth: authRoles.admin
    },
    {
        path: '/casting',
        element: <List />,
        auth: authRoles.admin
    },
    {
        path: '/casting/edit/:id',
        element: <Update />,
        auth: authRoles.admin
    },
    {
        path: '/casting/view/:id',
        element: <View />,
        auth: authRoles.admin
    }
];

export default castingRoutes;